import { Component, OnInit } from "@angular/core";
import { Router, NavigationStart, Event, NavigationEnd } from "@angular/router";
import { PlatformLocation } from "@angular/common";
import { CookieService } from "ngx-cookie-service";
import { OwlOptions } from "ngx-owl-carousel-o";
import { environment } from "src/environments/environment";
import { EncryptDecryptService } from "src/app/encrypt-decrypt.service";
declare var $: any;

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  isTreatment = false;
  isGeneralTreatments = false;
  isPreventativeTreatments = false;
  isCosmeticTreatments = false;
  isMissingTeethTreatments = false;
  isBracesTreatments = false;
  isBoldBeautifulTreatments = false;
  isAbout = false;
  clicked: Boolean;
  isConsicousTreatments = false;
  isReferal = false;
  isTechnology = false;
  isHomeDental = true;
  isFaqs = false;
  isBlogs =false;
  isServices = false;
  isTreatmentGalary=false;
  isPatient = false;
  videoCdnUrl = environment.googleCDNUrl;
  isPractice = false;
  isLoggedIn=false;
  isLogged = false;

  
  treatmentCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist-white.svg",
      treatmentTitle: "General Treatments",
      treatmentSectionTitle: "GeneralTreatments",
      treatmentLink: "Treatments,{TreatmentType:GeneralTreatments}",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth-white.svg",
      treatmentTitle: "Preventative",
      treatmentSectionTitle: "PreventativeDentistry",
      treatmentLink: "['Treatments',{TreatmentType:PreventativeDentistry}]",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth-white.svg",
      treatmentTitle: "Cosmetic Dentistry",
      treatmentSectionTitle: "CosmeticDentistry",
      treatmentLink: "[Treatments,{TreatmentType:CosmeticDentistry}]",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/swollen-white.svg",
      treatmentTitle: "Missing Teeth",
      treatmentSectionTitle: "MissingTeeth",
      treatmentLink: "[Treatments,{TreatmentType:MissingTeeth}]",
    },
    {
      id: 5,
      treatmentImage: this.videoCdnUrl + "images/dental-white.svg",
      treatmentTitle: "Braces",
      treatmentSectionTitle: "Braces",
      treatmentLink: "[Treatments,{TreatmentType:Braces}]",
    },
    {
      id: 6,
      treatmentImage: this.videoCdnUrl + "images/bold-beauty-white.svg",
      treatmentTitle: "Bold & Beautiful",
      treatmentSectionTitle: "Bold-Beautiful",
      treatmentLink: "[Treatments,{TreatmentType:Bold-Beautiful}]",
    },
    {
      id: 7,
      treatmentImage: this.videoCdnUrl + "images/teeth-white.svg",
      treatmentTitle: "Sedation",
      treatmentSectionTitle: "ConsciousSedation",
      treatmentLink: "[Treatments,{TreatmentType:ConsciousSedation}]",
    },
  ];

  GeneralTreatments = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist.svg",
      treatmentTitle: "Root Canal Therapy",
      treatmentSectionTitle: "RootCanalTherapy",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Emergency Dental Care",
      treatmentSectionTitle: "EmergencyDentalCare",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Extraction / Oral Surgery",
      treatmentSectionTitle: "ExtractionOralSurgery",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/swollen.svg",
      treatmentTitle: "Crowns",
      treatmentSectionTitle: "Crowns",
    },
    {
      id: 5,
      treatmentImage: this.videoCdnUrl + "images/dental.svg",
      treatmentTitle: "Pregnant Women",
      treatmentSectionTitle: "PregnantWomen",
    },
    {
      id: 6,
      treatmentImage: this.videoCdnUrl + "images/bold-beauty.svg",
      treatmentTitle: "Mouth Cancer Screening",
      treatmentSectionTitle: "MouthCancerScreening",
    },
  ];

  PreventativeDentistry = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist.svg",
      treatmentTitle: "Healthy Gums",
      treatmentSectionTitle: "HealthyGums",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Dental Hygiene",
      treatmentSectionTitle: "DentalHygiene",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Sensitive Teeth",
      treatmentSectionTitle: "SensitiveTeeth",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/swollen.svg",
      treatmentTitle: "Children's Teeth",
      treatmentSectionTitle: "ChildrenTeeth",
    },
    {
      id: 5,
      treatmentImage: this.videoCdnUrl + "images/dental.svg",
      treatmentTitle: "Smoking Cessation",
      treatmentSectionTitle: "SmokingCessation",
    },
  ];

  CosmeticDentistry = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist.svg",
      treatmentTitle: "White Fillings",
      treatmentSectionTitle: "WhiteFillings",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Porcelain Veneers",
      treatmentSectionTitle: "PorcelainVeneers",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Inlays & Onlays",
      treatmentSectionTitle: "InlaysOnlays",
    },
  ];

  MissingTeeth = [
    // {
    //   id: 1,
    //   treatmentImage: this.videoCdnUrl+"images/dentist.svg",
    //   treatmentTitle: "Dental Implants",
    //   treatmentSectionTitle: "DentalImplants"
    // },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Bridges",
      treatmentSectionTitle: "Bridges",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Dentures",
      treatmentSectionTitle: "Dentures",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/swollen.svg",
      treatmentTitle: "Denture Stabilisation",
      treatmentSectionTitle: "DentureStabilisation",
    },
  ];

  ConsciousSedation = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dental.svg",
      treatmentTitle: "Conscious Sedation",
      treatmentSectionTitle: "ConsciousSedation",
    },
  ];

  Braces = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist.svg",
      treatmentTitle: "Orthodontics",
      treatmentSectionTitle: "Orthodontics",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Invisalign",
      treatmentSectionTitle: "Invisalign",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Six Month Smiles",
      treatmentSectionTitle: "Six Month Smiles",
    },
  ];

  BoldBeautiful = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/dentist.svg",
      treatmentTitle: "Smile design",
      treatmentSectionTitle: "Smiledesign",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/tooth.svg",
      treatmentTitle: "Facial Aesthetics",
      treatmentSectionTitle: "BotoxFillings",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/teeth.svg",
      treatmentTitle: "Teeth Whitening",
      treatmentSectionTitle: "TeethWhitening",
    },
  ];

  DentalImplantMenu = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/SingleTooth.svg",
      treatmentTitle: "Single Tooth",
      treatmentSectionTitle: "SingleTooth",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/multipleTeeth.svg",
      treatmentTitle: "Multiple Teeth",
      treatmentSectionTitle: "MultipleTeeth",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/AllTeeth.svg",
      treatmentTitle: "All Teeth",
      treatmentSectionTitle: "AllTeeth",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/Dentures.svg",
      treatmentTitle: "Implant Retained Dentures",
      treatmentSectionTitle: "ImplantRetainedDentures",
    },
  ];

  treatmentOptions: OwlOptions = {
    items: 9,
    dots: false,
    // nav: false,
    navText: [
      "<img loading='lazy' src='https://storage.googleapis.com/smileorchard/images/backWhite.svg' style='color:black' height='10' width='10'>",
      "<img loading='lazy' src='https://storage.googleapis.com/smileorchard/images/nextWhite.svg' style='color:black' height='10' width='10'>",
    ],
    // autoPlay: false,
    margin: 0,
    // responsiveClass: true,
    responsive: {
      0: {
        items: 2,
        nav: true,
        // arrows: true,
        loop: true,
        // autoPlay: true,
        //
      },
      1000: {
        items: 9,
        nav: false,
        // autoPlay: true,
        // loop:true
      },
    },
  };

  GeneralTreatmentstreatmentOptions = {
    items: this.GeneralTreatments.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  PreventativeDentistrytreatmentOptions = {
    items: this.PreventativeDentistry.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  CosmeticDentistrytreatmentOptions = {
    items: this.CosmeticDentistry.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  MissingTeethtreatmentOptions = {
    items: this.MissingTeeth.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  BracestreatmentOptions = {
    items: this.Braces.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  BoldBeautifulTreatments = {
    items: this.BoldBeautiful.length,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  AboutCarouselOptions = {
    items: 3,
    dots: false,
    nav: false,
    autoPlay: false,
    margin: 0,
    responsiveClass: true,
    responsive: {
      0: {
        items: 3,
        nav: false,
        arrows: false,
        loop: true,
        autoPlay: true,
      },
      600: {
        items: 6,
        nav: false,
        autoPlay: true,
        // loop:true
      },
    },
  };

  AboutCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/about-white.svg",
      treatmentTitle: "About Us",
      treatmentSectionTitle: "AboutUs",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/dentistTeam-white.svg",
      treatmentTitle: "Our Team",
      treatmentSectionTitle: "OurTeam",
    },
  ];

  ReferralCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/referYourself-white.svg",
      treatmentTitle: "Refer Yourself",
      treatmentSectionTitle: "ReferYourself",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/referPatient-white.svg",
      treatmentTitle: "Refer a Patient",
      treatmentSectionTitle: "ReferApatient",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/cbctRefer-white.svg",
      treatmentTitle: "CBCT Referral",
      treatmentSectionTitle: "CBCTReferal",
    },
  ];

  TechnologyCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/LaserDentistry.svg",
      treatmentTitle: "Laser Dentistry",
      treatmentSectionTitle: "LaserDentistry",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/3dscan-white.svg",
      treatmentTitle: "Advanced 3D Scanner",
      treatmentSectionTitle: "Advanced3DScanner",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/x-ray-white.svg",
      treatmentTitle: "CBCT Scanner",
      treatmentSectionTitle: "CBCTScanner",
    },
    {
      id: 4,
      treatmentImage: this.videoCdnUrl + "images/oralscan-white.svg",
      treatmentTitle: "Intra Oral Camera",
      treatmentSectionTitle: "IntraOralCamera",
    },
  ];

  FAQCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/FAQs-white.svg",
      treatmentTitle: "Treatment FAQs",
      treatmentSectionTitle: "TreatmentFAQs",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/Glossary-white.svg",
      treatmentTitle: "Smile Glossary",
      treatmentSectionTitle: "SmileGlossary",
    },
  ];
  ServicesCarousel = [
    {
      id: 1,
      treatmentImage: this.videoCdnUrl + "images/FAQs-white.svg",
      treatmentTitle: "First Consultation",
      treatmentSectionTitle: "Consultation",
    },
    {
      id: 2,
      treatmentImage: this.videoCdnUrl + "images/Glossary-white.svg",
      treatmentTitle: "Laser Dentistry",
      treatmentSectionTitle: "Laser",
    },
    {
      id: 3,
      treatmentImage: this.videoCdnUrl + "images/Glossary-white.svg",
      treatmentTitle: "Same Day Dentistry",
      treatmentSectionTitle: "Dentistry",
    },
  ];
  currentUrl: string;
  isHome = false;
  //isLoggedIn = false;
  UserName;
  isDentist = false;
  constructor(
    private router: Router,
    location: PlatformLocation,
    private cookieService: CookieService,
    private encDecService: EncryptDecryptService
  ) {
    this.router.events.subscribe((routerEvent: Event) => {
    this.isLoggedIn = false;

      if (this.cookieService.get("isLoggedIn")) {
        this.isLoggedIn = true;
        if (this.cookieService.get("Role") === "Dentist") {
          this.isDentist = true;
          this.isPatient = false;
          this.isPractice = false;
          this.UserName =
            this.encDecService.dec(this.cookieService.get("FirstName")) +
            " " +
            this.encDecService.dec(this.cookieService.get("LastName"));
        } else if (this.cookieService.get("Role") === "Patient") {
          this.isPatient = true;
          this.isDentist = false;
          this.isPractice = false;
          this.UserName =
            this.encDecService.dec(this.cookieService.get("FirstName")) +
            " " +
            this.encDecService.dec(this.cookieService.get("LastName"));
        } else if (this.cookieService.get("Role") === "Practice") {
          this.isPatient = false;
          this.isDentist = false;
          this.isPractice = true;
          this.UserName = this.encDecService.dec(this.cookieService.get("PracticeName"));
          // + " "+this.encDecService.dec(this.cookieService.get("PracticeName"));
        } else {
          this.isPatient = false;
          this.isDentist = false;
          this.isPractice = false;
        }
      } else {
        this.isLoggedIn = false;
      }
      if (routerEvent instanceof NavigationStart) {
        location.onPopState(() => {
          window.location.reload();
        });

        this.currentUrl = routerEvent.url.substring(
          routerEvent.url.lastIndexOf("/") + 1
        );

        if (
          this.currentUrl.trim() === "" ||
          this.currentUrl.trim() === "Home"
        ) {
          this.isHome = false;
          this.isReferal = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isTreatment = false;
          this.isHomeDental = true;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isLoggedIn = false; 
          this.isTreatmentGalary=false;                          

          if (this.cookieService.get("isLoggedIn")) {
            this.isLoggedIn = true;
          } else {
            this.isLoggedIn = false;
          }
          const newThis = this;
          $(window).on("scroll", function () {
            // newThis.isHome = true
            var $w = $(this),
              st = $w.scrollTop(),
              navbar = $(".smileOrchard-navbar"),
              sd = $(".js-scroll-wrap");

            if (st > 150) {
              if (navbar.hasClass("scrolled")) {
                newThis.isHome = true;
                navbar.addClass("scrolled awake");
              }
            }
            if (st < 150) {
              newThis.isHome = false;
              navbar.removeClass("scrolled sleep");
            }
          });
          $(".navbar").removeAttr("position");
          var $w = $(this),
            st = $w.scrollTop(),
            navbar = $(".smileOrchard-navbar"),
            sd = $(".js-scroll-wrap");
          if (navbar.hasClass("scrolled")) {
            newThis.isHome = false;
            navbar.removeClass("scrolled sleep");
          }
        } else if (
          this.currentUrl.trim() === "About%20Us" ||
          this.currentUrl.trim().split(";")[0] === "About%20Us" ||
          this.currentUrl.trim() === "Our%20Team" ||
          this.currentUrl.trim().split(";")[0] === "Our%20Team"
        ) {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isAbout = true;
          this.isHome = false;
          this.isReferal = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isTreatment = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
        } else if (
          this.currentUrl.trim() === "Technology" ||
          this.currentUrl.trim().split(";")[0] === "Technology"
        ) {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isTechnology = true;
          this.isHome = false;
          this.isReferal = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isTreatment = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
        } else if (
          this.currentUrl.trim() === "Treatments" ||
          this.currentUrl.trim().split(";")[0] === "Treatments" ||
          this.currentUrl.trim() === "Dental%20Implant" ||
          this.currentUrl.trim().split(";")[0] === "Dental%20Implant" ||
          this.currentUrl.trim().split(";")[0] === "Dentures" ||
          this.currentUrl.trim().split(";")[0] === "Bridges" ||
          this.currentUrl.trim().split(";")[0] === "Denture%20Stabilisation" ||
          this.currentUrl.trim().split(";")[0] === "Orthodontics" ||
          this.currentUrl.trim().split(";")[0] === "Invisalign" ||
          this.currentUrl.trim().split(";")[0] === "Six%20Month%20Smiles" ||
          this.currentUrl.trim().split(";")[0] === "Conscious%20Sedation"
        ) {
          $("html,body").animate(
            { scrollTop: $("#smileOrchard-navbar").offset() },
            "slow"
          );
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isTreatment = true;
          this.isHome = false;
          this.isReferal = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary = false;
        } else if (
          this.currentUrl.trim() === "Referrals" ||
          this.currentUrl.trim() === "dentist-referals" ||
          this.currentUrl.trim().split(";")[0] === "dentist-referals" ||
          this.currentUrl.trim() === "practice-referrals" ||
          this.currentUrl.trim().split(";")[0] === "practice-referrals" ||
          this.currentUrl.trim() === "practice-management" ||
          this.currentUrl.trim().split(";")[0] === "dentist-form" ||
          this.currentUrl.trim() === "dentist-form" ||
          this.currentUrl.trim().split(";")[0] === "practice-form" ||
          this.currentUrl.trim() === "practice-form" ||
          this.currentUrl.trim() === "referal-dentist-login" ||
          this.currentUrl.trim() === "referal-practice-login" ||
          this.currentUrl.trim() === "Refer%20Yourself" ||
          this.currentUrl.trim() === "Refer%20a%20Patient" ||
          this.currentUrl.trim() === "CBCT%20Referral" ||
          this.currentUrl.trim() === "referal-view" ||
          this.currentUrl.trim().split(";")[0] === "referal-view" ||
          this.currentUrl.trim().split(";")[0] === "Refer%20a%20Patient"
        ) {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isReferal = true;
          this.isTreatment = false;
          this.isHome = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
        } else if (this.currentUrl.trim().split(";")[0] === "Treatment") {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isTreatment = true;
          this.isHome = false;
          this.isReferal = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
        } else if (
          this.currentUrl.trim() === "Book%20an%20appointment" ||
          this.currentUrl.trim().split("?")[0] === "Book%20an%20appointment" ||
          this.currentUrl.trim().split(";")[0] === "Book%20an%20appointment" ||
          this.currentUrl.trim() === "Smile%20Design" ||
          this.currentUrl.trim() === "Botox%20&%20Fillers" ||
          this.currentUrl.trim() === "Membership" ||
          this.currentUrl.trim() === "Dentists%20Lounge" ||
          this.currentUrl.trim() === "Fees" ||
          this.currentUrl.trim() === "BlogHome" ||
          this.currentUrl.trim() === "view-blog" ||
          this.currentUrl.trim() === "blogs" ||
          this.currentUrl.trim() === "TreatmentGallery" ||
          this.currentUrl.trim().split(";")[0] === "view-blog" ||
          this.currentUrl.trim() === "Contact%20Us" ||
          this.currentUrl.trim().split(";")[0] === "Contact%20Us" ||
          this.currentUrl.trim() === "profile" ||
          this.currentUrl.trim().split(";")[0] === "profile" ||
          this.currentUrl.trim() === "Membership%20Form" ||
          this.currentUrl.trim().split(";")[0] === "Membership%20Form" ||
          this.currentUrl.trim().split("?")[0] === "VideoCall" ||
          this.currentUrl.trim() === "Log%20In" ||
          this.currentUrl.trim().split(";")[0] === "Log%20In" ||
          this.currentUrl.trim() === "forgotpassword" ||
          this.currentUrl.trim().split("?")[0] === "forgotpassword" ||
          this.currentUrl.trim().split(";")[0] === "forgotpassword" ||
          this.currentUrl.trim() === "Privacy%20Policy" ||
          this.currentUrl.trim().split(";")[0] === "Smile%20Gallery" ||
          this.currentUrl.trim().split(";")[0] === "payment" ||
          this.currentUrl.trim().split("?")[0] === "payment" ||
          this.currentUrl.trim() === "servicestimeline" ||
          this.currentUrl.trim() === "safety-security" ||
          this.currentUrl.trim() === "dentist-form" ||
          this.currentUrl.trim().split(";")[0] === "dentist-form"
        ) {
          this.isReferal = false;
          this.isTreatment = false;
          this.isHome = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
        } else if (
          this.currentUrl.trim() === "Faqs" ||
          this.currentUrl.trim().split(";")[0] === "Faqs"
        ) {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isFaqs = true;
          this.isBlogs =true;
          this.isTechnology = false;
          this.isHome = false;
          this.isReferal = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isTreatment = false;
          this.isHomeDental = false;
          this.isTreatmentGalary=true;
        } else if (
          this.currentUrl.trim() === "services" ||
          this.currentUrl.trim().split(";")[0] === "services"
        ) {
          $(".smileOrchard-navbar").addClass("awake scrolled");
          const newThis = this;
          $(window).on("scroll", function () {
            $(".smileOrchard-navbar").addClass("awake scrolled");
            newThis.isHome = false;
          });
          this.isServices = true;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isTechnology = false;
          this.isHome = false;
          this.isReferal = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isTreatment = false;
          this.isHomeDental = false;
          this.isTreatmentGalary=false;
        } else {
          this.isReferal = false;
          this.isTreatment = false;
          this.isHome = false;
          this.isTechnology = false;
          this.isMissingTeethTreatments = false;
          this.isPreventativeTreatments = false;
          this.isAbout = false;
          this.isBoldBeautifulTreatments = false;
          this.isBracesTreatments = false;
          this.isConsicousTreatments = false;
          this.isCosmeticTreatments = false;
          this.isGeneralTreatments = false;
          this.isHomeDental = false;
          this.isFaqs = false;
          this.isBlogs =false;
          this.isServices = false;
          this.isTreatmentGalary=false;
          const newThis = this;
          $(window).on("scroll", function () {
            newThis.isHome = false;
            var $w = $(this),
              st = $w.scrollTop(),
              navbar = $(".smileOrchard-navbar"),
              sd = $(".js-scroll-wrap");

            if (st > 150) {
              if (!navbar.hasClass("scrolled")) {
                navbar.addClass("scrolled awake");
                newThis.isHome = false;
              }
            }
            if (st < 150) {
              if (navbar.hasClass("scrolled")) {
                navbar.removeClass("scrolled sleep");
                newThis.isHome = false;
              }
            }
          });
          $(".navbar").removeAttr("position");
          var $w = $(this),
            st = $w.scrollTop(),
            navbar = $(".smileOrchard-navbar"),
            sd = $(".js-scroll-wrap");
          if (navbar.hasClass("scrolled")) {
            navbar.removeClass("scrolled sleep");
            newThis.isHome = false;
          }
        }
      }
    });
  }

  ngOnInit() {
  
    this.isLogged = false;
    $("html,body").animate(
      { scrollTop: $("#smileOrchard-navbar").offset().top - 300 },
      "slow"
    );  

    if (this.cookieService.get("isLoggedIn")) {
      this.isLoggedIn = true;
      if (this.cookieService.get("Role") === "Dentist") {
        this.isDentist = true;
        this.isPatient = false;
        this.isPractice = false;
        this.UserName =
          this.encDecService.dec(this.cookieService.get("FirstName")) +
          " " +
          this.encDecService.dec(this.cookieService.get("LastName"));
      } else if (this.cookieService.get("Role") === "Patient") {
        this.isPatient = true;
        this.isDentist = false;
        this.isPractice = false;
        this.UserName =
          this.encDecService.dec(this.cookieService.get("FirstName")) +
          " " +
          this.encDecService.dec(this.cookieService.get("LastName"));
      } else if (this.cookieService.get("Role") === "Practice") {
        this.isPatient = false;
        this.isDentist = false;
        this.isPractice = true;
        this.UserName = this.encDecService.dec(this.cookieService.get("PracticeName"));
        // + " "+this.encDecService.dec(this.cookieService.get("PracticeName"));
      } else {
        this.isPatient = false;
        this.isDentist = false;
        this.isPractice = false;
      }
    } else {
      this.isLoggedIn = false;
    }
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0);
    });

    $(".nav-item").on("click", function () {
      $("#ftco-nav").removeClass("show");
    });

    $(window).on("scroll", function () {
      $("#ftco-nav").removeClass("show");
    });

    $(".navbar-brand").on("click", function () {
      $("#ftco-nav").removeClass("show");
      $(".nav-link").removeClass("active");
    });

    $(".navbar-toggler").on("click", function () {
      // if($('#ftco-nav').hasClass('show')){
      $(".navbar-collapse").removeClass("show");
      // }else{
      //   $('.navbar-collapse').addClass('show')
      // }
    });

    $(".owl-item.active").on("click", function () {
      $(".owl-item.active").addClass("active-item-border");
    });
  }

  closeDropdown() {
    // if($('.dropdown-menu').hasClass('show')){
    //   $('.dropdown-menu').removeClass('show')
    // }else{
    //   $('.dropdown-menu').addClass('show')
    // }
    // $('.dropdown-menu').css('display','none')
  }
  scrollTo(element) {
    var newEle = document.getElementById(element);
    newEle.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  logOut() {
    this.cookieService.delete("isLoggedIn");
    this.cookieService.delete("PatientID");
    this.cookieService.delete("FirstName");
    this.cookieService.delete("PracticeName");
    this.cookieService.delete("LastName");
    this.cookieService.delete("Email");
    this.cookieService.delete("Phone");
    this.cookieService.delete("DentistID");
    this.cookieService.delete("PracticeID");
    this.cookieService.delete("Role");
    this.cookieService.delete("MembershipPatientLinkID");
    this.cookieService.delete("MembershipStatus");
    if (this.router.url === "/") {
      window.location.reload();
    } else {
      this.router.navigate(["/"]);
    }
    // window.location.reload()
  }

  viewMyReferrals() {
    if (this.isDentist) {
      this.router.navigate([
        "dentist-referals",
        {
          DentistID: this.cookieService.get("DentistID"),
          type: "dentist",
        },
      ]);
    } else if (this.isPractice) {
      this.router.navigate(["/practice-referrals", { Type: "practice" }]);
    }
  }

  viewMyProfile() {
    this.router.navigate(["/profile"]);
  }

  viewOurDentists() {
    this.router.navigate(["/practice-management"]);
  }

  BookAnAppointment() {
    this.router.navigate(["/Contact Us"]);
    // if (this.cookieService.get("isLoggedIn")) {
    //   this.router.navigate(["/Contact Us"]);
    // } else {
    //   this.router.navigate(["/Log In", { IsAppointment: 1 }]);
    // }
  }
}
